import { DispensaryCollectionPage } from 'src/dispensary/collection';
import { MainDispensaryLayout } from 'src/components/layouts/main-dispensary-layout';

export default Object.assign(DispensaryCollectionPage, { layout: MainDispensaryLayout });
